import { COURSE_HOUSING_TYPES, COURSE_TYPES } from "../constants";

export const replaceForURLOptions = (data) => {
  const URLOptions = {} as any;

  if (data.courseType) {
    URLOptions.courseType = data.courseType.id;
  }

  if (data.housingType) {
    URLOptions.housingType = data.housingType.id;
  }

  return URLOptions;
};

export const replaceForFilterForm = (data) => {
  const filterForm = {} as any;

  if (data.courseType) {
    filterForm.courseType = {
      id: data.courseType,
      name: COURSE_TYPES.find((type) => type.id === data.courseType)!.name,
    };
  }

  if (data.housingType) {
    filterForm.housingType = {
      id: data.housingType,
      name: COURSE_HOUSING_TYPES.find((type) => type.id === data.housingType)!
        .name,
    };
  }

  return filterForm;
};
